/**
 * Número do contato no botão de copiar do cabeçalho da conversa.
 *
 * Brasil (55 + DDD + número, com ou sem o 9): mostra "(61) 98123-4567" e copia
 * só DDD + número, sem DDI, parênteses, espaço ou traço — "61981234567"
 * (pedido do dono, 01/nov/2026).
 *
 * Fora do Brasil não há DDD pra separar: mostra "+<dígitos>" e copia os dígitos
 * inteiros — sem o código do país o número não serve pra nada.
 *
 * `null` = nada que pareça telefone (contato sem número, ex.: Instagram).
 */
export function numeroDoContato(
  telefone: string | null | undefined,
): { exibir: string; copiar: string } | null {
  const digitos = (telefone ?? '').replace(/\D/g, '');
  if (digitos.length < 8) return null;
  if (digitos.startsWith('55') && (digitos.length === 12 || digitos.length === 13)) {
    const local = digitos.slice(2);
    const ddd = local.slice(0, 2);
    const numero = local.slice(2);
    const corte = numero.length - 4;
    return {
      exibir: `(${ddd}) ${numero.slice(0, corte)}-${numero.slice(corte)}`,
      copiar: local,
    };
  }
  return { exibir: `+${digitos}`, copiar: digitos };
}
